import { Component } from '@wordpress/element';
import { generateCustomStyleCode } from '../../extensions/custom-styles';

class BaseWrapper extends Component {
	componentDidMount() {
		const {
			attributes,
			setAttributes,
			clientId,
		} = this.props;
		const { blockAdvanceOptions, isSaved } = attributes;

		let saveIt = false;
		if ( ! isSaved ) {
			setAttributes( { isSaved: true, blockClientId: clientId } );
			saveIt = true;
		}
		generateCustomStyleCode( blockAdvanceOptions, { ...this.props }, saveIt );
	}

	render() {
		const { clientId, children, name, attributes } = this.props;
		const { blockClientId } = attributes;
		const baseClass = name.replace( '/', '-' ) + '-section';
		const _blockClientId = '' !== blockClientId ? blockClientId : clientId;
		return <div id={ `gutenify-section-${ _blockClientId }` } className={ baseClass }>{ children }</div>;
	}
}
export default BaseWrapper;
